import { useCallback } from 'react'

import ScAnalytics from 'classes/sc_analytics'
import { modalEnum } from 'components/modals/v2/modal'
import { useModalContext } from 'hooks/use_context'

const useNavigateSignUp = () => {
  const { onOpenModal } = useModalContext()

  return useCallback(
    (label, section, page) => {
      ScAnalytics.sendUserInitFunnel(label, section, page)
      onOpenModal(modalEnum.signUp)
    },
    [onOpenModal]
  )
}

export default useNavigateSignUp
